import transitionPage from "@/components/transitionPage/index";
import suggestionApps from "@/components/suggestionApps/index";
import Language from "@/components/appbar/Language";
// import $lang from "@/mixins/lang";

export default {
  name: "auth",
  components: { transitionPage, suggestionApps, Language },
  props: [],
  mixins: [],
  data() {
    return {
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL
    };
  },
  mounted() {
    this.init();
  },
  computed: {},
  methods: {
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("isDark", this.$vuetify.theme.dark);
    },
    init() {
      const queryLang = this.$route.query.lang;
      if (!queryLang) return;
      if (queryLang !== "en" && queryLang !== "fa") return;

      const isEnglish = queryLang === "en";
      const lang = isEnglish ? "en" : "fa";
      const direction = isEnglish ? "ltr" : "rtl";

      this.$vuetify.rtl = !isEnglish;
      this.$i18n.locale = lang;

      localStorage.setItem("lang", lang);
      localStorage.setItem("direction", direction);

      this.$cookies.set("lang", lang);
    }
  }
};
